import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CgSearch } from 'react-icons/cg';
import { IoIosCloseCircle } from 'react-icons/io';

import * as S from './styles';

const CLOSE_ZOOM = 16;

interface ISearchBoxGoogle {
  googleMaps?: any;
  searchValue?: string | undefined;
  setSearchValue?: Function;
  onPlacesChanged?: Function;
  clearLocation?: Function;
}

const SearchBoxGoogle = ({
  googleMaps,
  searchValue,
  setSearchValue,
  onPlacesChanged,
  clearLocation,
}: ISearchBoxGoogle) => {
  const inputRef = useRef(null);
  const searchBox = useRef(null);

  const [search, setSearch] = useState('');
  const [placeActive, setPlaceActive] = useState();

  useEffect(() => {
    if (searchValue) {
      setSearch(searchValue);
    }
  }, [searchValue]);

  useEffect(() => {
    if (placeActive && onPlacesChanged) {
      onPlacesChanged(placeActive);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeActive]);

  const handleOnPlacesChanged = useCallback(() => {
    // @ts-ignore
    const place = searchBox?.current?.getPlaces()?.[0];
    const pointLocation = place?.geometry?.location;
    const placeAddress = place?.formatted_address;
    setSearch(placeAddress);
    setSearchValue?.(placeAddress);
    if (pointLocation) {
      setPlaceActive({
        // @ts-ignore
        lat: pointLocation.lat(),
        lng: pointLocation.lng(),
        zoom: CLOSE_ZOOM,
      });
    }
  }, [setSearchValue]);

  useEffect(() => {
    if (!searchBox.current && googleMaps) {
      searchBox.current = new googleMaps.places.SearchBox(inputRef.current);
      // @ts-ignore
      searchBox.current?.addListener('places_changed', handleOnPlacesChanged);
    }

    return () => {
      if (googleMaps) {
        searchBox.current = null;
        googleMaps.event.clearInstanceListeners(searchBox);
      }
    };
  }, [googleMaps, handleOnPlacesChanged]);

  useEffect(() => {
    if (googleMaps) {
      const { searchParams } = new URL(window.location.href);
      const lat = searchParams.get('lat');
      const lng = searchParams.get('lng');
      if (lat && lng) {
        setSearchValue?.(`${lat},${lng}`);
      }
    }
  }, [setSearchValue, googleMaps]);

  const handleClearSearch = useCallback(() => {
    setSearch('');
    setSearchValue?.(undefined);
    clearLocation?.();
  }, [clearLocation, setSearchValue]);

  return (
    <S.SearchGoogleContainer>
      <input
        type="text"
        ref={inputRef}
        value={search}
        onChange={({ target: { value } }) => setSearch(value)}
      />
      {search && (
        <IoIosCloseCircle
          className="search-in-map-close"
          onClick={handleClearSearch}
        />
      )}
      <CgSearch className="search-in-map-icon" />
    </S.SearchGoogleContainer>
  );
};

export default SearchBoxGoogle;
